/* Plastics Co homepage (pcoh-*): finder, dispatch countdown, best-seller tabs, material selector.
   Loaded with defer by several sections; the guard keeps it to one run. */
(function () {
  if (window.PCOH) return;
  window.PCOH = true;

  var NOUN = { sheet: 'sheets', rod: 'rods', tube: 'tubes' };
  var DIMS = { sheet: 'T × W × L', rod: 'Ø × L', tube: 'OD × ID × L' };
  var SKETCH = {
    sheet: '<path class="shade" d="M8 52 L8 62 L82 90 L82 80 Z"/><path class="shade" d="M82 80 L82 90 L142 60 L142 50 Z"/><path class="body" d="M8 52 L68 24 L142 50 L82 80 Z"/>' +
      '<path class="dim" d="M4 58 L4 68 M2 58h4 M2 68h4"/><text class="dimtxt" x="-4" y="78">T</text>' +
      '<path class="dim" d="M14 44 L66 18"/><text class="dimtxt" x="30" y="24">W</text>' +
      '<path class="dim" d="M74 18 L144 42"/><text class="dimtxt" x="112" y="24">L</text>',
    rod: '<path class="body" d="M22 22 H132 A10 26 0 0 1 132 74 H22 Z"/><ellipse class="body" cx="22" cy="48" rx="10" ry="26"/>' +
      '<path class="dim" d="M4 22 V74 M1 22h6 M1 74h6"/><text class="dimtxt" x="-6" y="16">Ø</text>' +
      '<path class="dim" d="M22 88 H132 M22 85v6 M132 85v6"/><text class="dimtxt" x="74" y="84">L</text>',
    tube: '<path class="body" d="M22 22 H132 A10 26 0 0 1 132 74 H22 Z"/><ellipse class="body" cx="22" cy="48" rx="10" ry="26"/><ellipse cx="22" cy="48" rx="5" ry="13" fill="#fff" stroke="#0B1F38" stroke-width="1.4"/>' +
      '<path class="dim" d="M4 22 V74 M1 22h6 M1 74h6"/><text class="dimtxt" x="-10" y="16">OD</text>' +
      '<path class="dim" d="M40 35 V61 M37 35h6 M37 61h6"/><text class="dimtxt" x="46" y="51">ID</text>' +
      '<path class="dim" d="M22 88 H132 M22 85v6 M132 85v6"/><text class="dimtxt" x="74" y="84">L</text>'
  };

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* ---------- Finder ---------- */
  function initFinder(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    var data;
    try { data = JSON.parse(form.querySelector('[data-pcoh-finder-data]').textContent); } catch (e) { return; }
    var sel = form.querySelector('select'), go = form.querySelector('[data-pcoh-go]');
    var readout = form.querySelector('[data-pcoh-readout]'), sketch = form.querySelector('[data-pcoh-sketch]');
    var lastLabel = null;

    function shape() { var r = form.querySelector('input[name="pcoh-shape"]:checked'); return r ? r.value : 'rod'; }
    function items() { return data.filter(function (d) { return d.shape === shape(); }); }

    function fill() {
      var list = items();
      sel.innerHTML = list.map(function (m, i) { return '<option value="' + i + '">' + esc(m.label) + '</option>'; }).join('');
      var keep = -1;
      list.forEach(function (m, i) { if (keep < 0 && m.short === lastLabel) keep = i; });
      sel.value = keep > -1 ? keep : 0;
      update();
    }
    function update() {
      var s = shape(), m = items()[sel.value || 0];
      if (!m) return;
      lastLabel = m.short;
      sketch.innerHTML = SKETCH[s];
      sketch.style.setProperty('--mat', m.swatch || '#F4F1E8');
      readout.innerHTML = '<strong>' + esc(m.short) + ' ' + NOUN[s] + '</strong>' +
        'Cut to size · <span>' + DIMS[s] + '</span><br>' +
        (m.price ? 'From <span class="price">' + esc(m.price) + '</span> · pick your size next' : 'Pick your size on the next page');
      go.href = m.url;
      go.textContent = 'Show ' + m.short.toLowerCase() + ' ' + NOUN[s] + ' & prices';
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'pcoh-shape') fill(); else update(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); window.location.href = go.href; });
    fill();
  }

  /* ---------- Dispatch countdown (UK time, Mon–Fri cut-off) ---------- */
  function initDispatch(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
    var label = el.querySelector('[data-pcoh-dispatch-text]');
    function tick() {
      var o = {};
      try {
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
          .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
      } catch (e) { return; }
      var h = parseInt(o.hour, 10) % 24, m = parseInt(o.minute, 10);
      var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(o.weekday) > -1;
      var left = cutoff * 60 - (h * 60 + m);
      if (weekday && left > 0) {
        var hh = Math.floor(left / 60), mm = left % 60;
        label.innerHTML = 'Order within <b>' + (hh ? hh + 'h ' : '') + mm + 'm</b> for same-day dispatch';
      } else {
        var next = (o.weekday === 'Fri' || o.weekday === 'Sat' || o.weekday === 'Sun') ? 'on Monday' : 'tomorrow';
        label.innerHTML = 'Order now for dispatch <b>' + next + '</b>';
      }
    }
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    function select(t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on);
        x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        var n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); select(n);
      });
    });
  }

  /* ---------- Material selector ---------- */
  function initCompare(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var body = root.querySelector('tbody'), rows = [].slice.call(body.rows);
    var chips = [].slice.call(root.querySelectorAll('[data-need]'));
    var reset = root.querySelector('[data-pcoh-reset]'), count = root.querySelector('[data-pcoh-match]');
    var picked = [];
    rows.forEach(function (r, i) { r.dataset.order = i; });

    function render() {
      var full = 0;
      var scored = rows.map(function (r) {
        var tags = (r.getAttribute('data-tags') || '').split(' ');
        var score = picked.filter(function (k) { return tags.indexOf(k) > -1; }).length;
        var all = picked.length && score === picked.length;
        if (all) full++;
        r.classList.toggle('is-hit', !!all);
        r.classList.toggle('is-dim', picked.length > 0 && score === 0);
        [].forEach.call(r.querySelectorAll('[data-k]'), function (s) { s.classList.toggle('is-on', picked.indexOf(s.getAttribute('data-k')) > -1); });
        return { r: r, score: score };
      });
      scored.sort(function (a, b) { return (b.score - a.score) || (a.r.dataset.order - b.r.dataset.order); });
      scored.forEach(function (x) { body.appendChild(x.r); });
      reset.hidden = !picked.length;
      count.textContent = picked.length ? (full + ' of ' + rows.length + ' materials meet all ' + picked.length + ' need' + (picked.length > 1 ? 's' : '')) : '';
    }
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-need'), i = picked.indexOf(k);
        if (i > -1) picked.splice(i, 1); else picked.push(k);
        b.setAttribute('aria-pressed', i < 0);
        render();
      });
    });
    reset.addEventListener('click', function () {
      picked = [];
      chips.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      render();
    });
  }

  function init(scope) {
    [].forEach.call(scope.querySelectorAll('[data-pcoh-finder]'), initFinder);
    [].forEach.call(scope.querySelectorAll('[data-pcoh-dispatch]'), initDispatch);
    [].forEach.call(scope.querySelectorAll('[data-pcoh-tabs]'), initTabs);
    [].forEach.call(scope.querySelectorAll('[data-pcoh-compare]'), initCompare);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
